export function union(setA, setB) {
    return new Set([...setA, ...setB]);
}
export function difference(setA, setB) {
    const firstHalf = new Set([...setA].filter((v) => !setB.has(v)));
    const secondHalf = new Set([...setB].filter((v) => !setA.has(v)));
    return union(firstHalf, secondHalf);
}
export function intersection(setA, setB) {
    const firstHalf = new Set([...setA].filter((v) => setB.has(v)));
    const secondHalf = new Set([...setB].filter((v) => setA.has(v)));
    return union(firstHalf, secondHalf);
}
export function isEqual(setA, setB) {
    return difference(setA, setB).size === 0;
}
//# sourceMappingURL=set-utils.js.map